module.exports = __webpack_public_path__ + "media/tkl_promo_final_V2_nosound.588d20bc.mp4";